export const getBlackfireConnectLink = (formatMessage, uui?: string) =>
  `${formatMessage({ id: "links.blackfire.connect" })}${
    uui ? `?target=/agents/${uui}` : ""
  }`;
